import React from "react";

const REASONS = [
  {
    title: "100% Online",
    description: "Complete your inspection through a live video call from your phone.",
  },
  {
    title: "No Shop Visit",
    description: "Save time, gas, and the hassle of driving to an inspection location.",
  },
  {
    title: "Simple Scheduling",
    description: "Book your inspection online and choose a time that works for you.",
  },
  {
    title: "Completed Inspection Form",
    description: "Receive your completed inspection form after the inspection is reviewed.",
  },
];

const WhyChooseSection = ({
  stepNumber = 5,
  title = "Why Choose RideInspector?",
  description = "A faster, more convenient way to complete your vehicle inspection without visiting a shop.",
  items = REASONS,
}) => {
  return (<>
    <section>
      <div className="container">
        <div className="row justify-content-between align-items-center mb-4 mb-lg-5">
          <div className="col-lg-12 col-md-12 text-center">
            <h2>Why Choose RideInspector?</h2>
          </div>
          <div className="col-lg-12 col-md-12 text-center">
            A faster, more convenient way to complete your vehicle inspection without visiting a shop.
          </div>
        </div>

        <div className="row">
          {REASONS.map((item, i) => (
            <div className="col-lg-3 col-md-6 mb-4 mb-lg-0 d-flex" key={i}>
              <div
                className="p-5 rounded active position-relative h-100 w-100 d-flex flex-column"
                style={{ boxShadow: "0 10px 30px 5px rgba(1, 164, 121, 0.06)" }}
              >
                <h5
                  className="mt-4 mb-3 d-flex align-items-start"
                  style={{ minHeight: "3rem" }} // ~2 lines at h5 size, adjust to your font-size/line-height
                >
                  {item.title}
                </h5>
                <p className="mb-0">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </>


  );
}

export default WhyChooseSection;